import { Redirect } from 'types/suggestions';
import { SearchHistoryItem } from '../use-search-history-context';
import { navigate } from './utils';
import { getURLWithLoggingContext } from 'utils/get-url-with-logging-context';
import { getSRPSuggestionUrl } from 'utils/get-srp-suggestion-url';

export const handleRedirect = (
  redirect: Redirect,
  addHistoryItem: (item: SearchHistoryItem) => void,
  responseId: string,
  searchHref: string,
) => {
  const { pageUrl, name, type } = redirect;
  const url = pageUrl ? getRedirectUrl(pageUrl) : getSRPSuggestionUrl(searchHref, name);

  const resultURL = getURLWithLoggingContext(url, responseId, name, type, 'redirect');

  if (resultURL) {
    addHistoryItem({
      title: name,
      url: resultURL,
    });
    navigate(resultURL);
  }
};

export const getRedirectUrl = (url: string) => {
  return url.endsWith('.html') ? `${url.slice(0, -5)}/` : url;
};
